import { useDeleteRegion } from '../hooks/useDeleteRegion';
import { ConfirmDialog } from '@/shared/components/ahkinia/ConfirmDialog/ConfirmDialog';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface DeleteRegionModalProps {
  regionId: string;
  regionName: string;
  open: boolean;
  onClose: () => void;
}

export function DeleteRegionModal({ regionId, regionName, open, onClose }: DeleteRegionModalProps) {
  const { deleteRegion, isDeleting } = useDeleteRegion();

  const handleConfirm = () => {
    deleteRegion(regionId, {
      onSuccess: () => {
        Notification.success({ title: 'Región eliminada exitosamente' });
        onClose();
      },
    });
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(v) => !v && onClose()}
      title="Eliminar región"
      description={
        <span data-testid="delete-region-message">
          ¿Estás seguro de eliminar la región <strong>{regionName}</strong>?
        </span>
      }
      onConfirm={handleConfirm}
      confirmLabel="Eliminar"
      confirmLoadingLabel="Eliminando..."
      isPending={isDeleting}
      data-testid="delete-region-modal"
    >
      <div className="p-3 bg-destructive/10 border border-destructive/30 rounded-md">
        <p className="text-sm text-destructive font-medium">
          Esta acción es irreversible y eliminará las regiones hijas asociadas.
        </p>
      </div>
    </ConfirmDialog>
  );
}
